<div class="manage-account" data-testid="manage-account-page">
  <div class="page-header">
    <div class="ma-header-row">
      <div class="ma-avatar" data-testid="profile-avatar" aria-hidden="true">
        <span *ngIf="userInitials; else avatarIcon">{{ userInitials }}</span>
        <ng-template #avatarIcon
          ><span class="material-icons">person</span></ng-template
        >
      </div>
      <div>
        <h1 class="page-header__title">
          {{ user.firstName }} {{ user.lastName }}
        </h1>
        <p class="page-header__subtitle">
          Manage your personal profile and company details.
        </p>
      </div>
    </div>
  </div>

  <div class="ma-cards">
  <!-- Name -->
  <section class="card ma-card" data-testid="profile-name-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Name</h2>
      <ng-container *ngIf="!editNameToggle">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          data-testid="profile-name-edit"
          (click)="editName()"
        >
          <span class="material-icons">edit</span> Edit
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn--primary ma-edit-btn"
        *ngIf="editNameToggle"
        data-testid="profile-name-save"
        (click)="saveName()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>
    <form [formGroup]="nameUpdate">
      <div class="ma-grid">
        <div class="ma-field" *ngIf="!editNameToggle">
          <span class="ma-field__label">First Name</span>
          <span class="ma-field__value">{{ user.firstName }}</span>
        </div>
        <div class="form-field" *ngIf="editNameToggle">
          <label class="form-label" for="firstName"
            >First Name<span class="req">*</span></label
          >
          <input
            id="firstName"
            type="text"
            formControlName="firstName"
            class="input"
            data-testid="profile-name-first-input"
          />
        </div>
        <div class="ma-field" *ngIf="!editNameToggle">
          <span class="ma-field__label">Last Name</span>
          <span class="ma-field__value">{{ user.lastName }}</span>
        </div>
        <div class="form-field" *ngIf="editNameToggle">
          <label class="form-label" for="lastName"
            >Last Name<span class="req">*</span></label
          >
          <input
            id="lastName"
            type="text"
            formControlName="lastName"
            class="input"
            data-testid="profile-name-last-input"
          />
        </div>
      </div>
    </form>
  </section>

  <!-- Email -->
  <section class="card ma-card" data-testid="profile-email-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Email</h2>
      <ng-container *ngIf="!editEmailToggle">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          data-testid="profile-email-edit"
          (click)="editEmail()"
        >
          <span class="material-icons">edit</span> Edit
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn--primary ma-edit-btn"
        *ngIf="editEmailToggle"
        data-testid="profile-email-save"
        (click)="saveEmail()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>
    <form [formGroup]="emailUpdate">
      <div class="ma-grid">
        <div class="ma-field" *ngIf="!editEmailToggle">
          <span class="ma-field__label">Login Email</span>
          <span class="ma-field__value">{{ user.email }}</span>
        </div>
        <div class="form-field" *ngIf="editEmailToggle">
          <label class="form-label" for="loginEmail"
            >Login Email<span class="req">*</span></label
          >
          <input
            id="loginEmail"
            type="text"
            formControlName="email"
            class="input"
            data-testid="profile-email-input"
          />
        </div>
      </div>
    </form>
  </section>

  <!-- Phone -->
  <section class="card ma-card" data-testid="profile-phone-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Phone</h2>
      <ng-container *ngIf="!editPhoneToggle">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          data-testid="profile-phone-edit"
          (click)="editPhone()"
        >
          <span class="material-icons">edit</span> Edit
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn--primary ma-edit-btn"
        *ngIf="editPhoneToggle"
        data-testid="profile-phone-save"
        (click)="savePhone()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>
    <div class="ma-grid">
      <div class="ma-field" *ngIf="!editPhoneToggle">
        <span class="ma-field__label">Primary Phone Number</span>
        <span class="ma-field__value">{{ user.phone }}</span>
      </div>
      <div class="form-field" *ngIf="editPhoneToggle">
        <label class="form-label" for="phone"
          >Primary Phone Number<span
            *ngIf="user.optInStatus === 'OPTED_IN' && user.usePhoneForSms"
            class="req"
            >*</span
          ></label
        >
        <input
          id="phone"
          type="text"
          [(ngModel)]="phone"
          class="input"
          data-testid="profile-phone-primary-input"
          [disabled]="
            (user.optInStatus === 'OPTED_IN' && user.usePhoneForSms) || false
          "
        />
      </div>
      <div class="ma-field" *ngIf="!editPhoneToggle">
        <span class="ma-field__label">Phone OS</span>
        <span class="ma-field__value">{{ user.phoneOs }}</span>
      </div>
      <div class="form-field" *ngIf="editPhoneToggle">
        <label class="form-label" for="phoneOS">Phone OS</label>
        <input
          id="phoneOS"
          type="text"
          [(ngModel)]="phoneOs"
          class="input"
          data-testid="profile-phone-os-input"
        />
      </div>
    </div>
    <p
      *ngIf="editPhoneToggle && user.optInStatus === 'OPTED_IN' && user.usePhoneForSms"
      class="ma-hint"
    >
      *You have opted in to SMS notification with this phone number. You must
      opt out first in order to make updates.
    </p>
    <div class="ma-grid">
      <div class="ma-field" *ngIf="!editPhoneToggle">
        <span class="ma-field__label">Secondary Phone Number</span>
        <span class="ma-field__value">{{ user.phone2 }}</span>
      </div>
      <div class="form-field" *ngIf="editPhoneToggle">
        <label class="form-label" for="phone2"
          >Secondary Phone Number<span
            *ngIf="user.optInStatus === 'OPTED_IN' && user.usePhone2ForSms"
            class="req"
            >*</span
          ></label
        >
        <input
          id="phone2"
          type="text"
          [(ngModel)]="phone2"
          class="input"
          data-testid="profile-phone-secondary-input"
          [disabled]="
            (user.optInStatus === 'OPTED_IN' && user.usePhone2ForSms) || false
          "
        />
      </div>
      <div class="ma-field" *ngIf="!editPhoneToggle">
        <span class="ma-field__label">Phone OS</span>
        <span class="ma-field__value">{{ user.phone2Os }}</span>
      </div>
      <div class="form-field" *ngIf="editPhoneToggle">
        <label class="form-label" for="phone2OS">Phone OS</label>
        <input
          id="phone2OS"
          type="text"
          [(ngModel)]="phone2Os"
          class="input"
          data-testid="profile-phone-secondary-os-input"
        />
      </div>
    </div>
    <p
      *ngIf="editPhoneToggle && user.optInStatus === 'OPTED_IN' && user.usePhone2ForSms"
      class="ma-hint"
    >
      *You have opted in to SMS notification with this phone number. You must
      opt out first in order to make updates.
    </p>
  </section>

  <!-- Address -->
  <section class="card ma-card" id="address" data-testid="profile-address-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Address</h2>
      <!-- Verify and Edit sit together at the end of the header. -->
      <div class="ma-card__actions">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          *ngIf="addressVerificationEnabled && addressVerificationNeeded && !editAddressToggle"
          [disabled]="verifyAddressDisabled"
          data-testid="profile-address-verify"
          (click)="verifyAddress()"
        >
          Verify Address
        </button>
        <ng-container *ngIf="!editAddressToggle">
          <button
            type="button"
            class="btn btn--secondary ma-edit-btn"
            data-testid="profile-address-edit"
            (click)="editAddress()"
          >
            <span class="material-icons">edit</span> Edit
          </button>
        </ng-container>
        <button
          type="button"
          class="btn btn--primary ma-edit-btn"
          *ngIf="editAddressToggle"
          data-testid="profile-address-save"
          (click)="saveAddress()"
        >
          <span class="material-icons">save</span> Save
        </button>
      </div>
    </div>
    <div class="ma-grid">
      <div class="ma-field" *ngIf="!editAddressToggle">
        <span class="ma-field__label">Street Address</span>
        <span class="ma-field__value">{{ user.location?.street }}</span>
      </div>
      <div class="form-field" *ngIf="editAddressToggle">
        <label class="form-label" for="street">Street Address</label>
        <input
          id="street"
          type="text"
          [(ngModel)]="streetAddress"
          class="input"
          data-testid="profile-address-street-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editAddressToggle">
        <span class="ma-field__label">City</span>
        <span class="ma-field__value">{{ user.location?.city }}</span>
      </div>
      <div class="form-field" *ngIf="editAddressToggle">
        <label class="form-label" for="city">City</label>
        <input
          id="city"
          type="text"
          [(ngModel)]="city"
          class="input"
          data-testid="profile-address-city-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editAddressToggle">
        <span class="ma-field__label">State</span>
        <span class="ma-field__value">{{
          decodeState(user.location?.state)
        }}</span>
      </div>
      <div class="form-field" *ngIf="editAddressToggle">
        <label class="form-label" for="profileState">State</label>
        <select
          id="profileState"
          class="form-select"
          [(ngModel)]="state"
          data-testid="profile-address-state-select"
        >
          <option
            *ngFor="let stateCountyDetail of stateCountyDetails"
            [value]="stateCountyDetail.state"
          >
            {{ stateCountyDetail.name }}
          </option>
        </select>
      </div>
      <div class="ma-field" *ngIf="!editAddressToggle">
        <span class="ma-field__label">Zip Code</span>
        <span class="ma-field__value">{{ user.location?.zipcode }}</span>
      </div>
      <div class="form-field" *ngIf="editAddressToggle">
        <label class="form-label" for="zipcode">Zip Code</label>
        <input
          id="zipcode"
          type="text"
          [(ngModel)]="zipcode"
          class="input"
          data-testid="profile-address-zipcode-input"
        />
      </div>
    </div>
  </section>

  <!-- Additional Information -->
  <section class="card ma-card" data-testid="profile-additional-info-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Additional Information</h2>
      <ng-container *ngIf="!editProfileAdditionalInfoToggle">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          data-testid="profile-additional-info-edit"
          (click)="editProfileAddtionalInfo()"
        >
          <span class="material-icons">edit</span> Edit
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn--primary ma-edit-btn"
        *ngIf="editProfileAdditionalInfoToggle"
        data-testid="profile-additional-info-save"
        (click)="saveProfileAdditionalInfo()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>
    <div class="ma-grid">
      <div class="ma-field" *ngIf="!editProfileAdditionalInfoToggle">
        <span class="ma-field__label">Bio</span>
        <span class="ma-field__value">{{ user.bio }}</span>
      </div>
      <div class="form-field" *ngIf="editProfileAdditionalInfoToggle">
        <label class="form-label" for="bio">Bio</label>
        <textarea
          id="bio"
          name="bio"
          class="input ma-textarea"
          rows="6"
          [(ngModel)]="bio"
          data-testid="profile-additional-info-bio-input"
        ></textarea>
      </div>
      <div class="ma-field" *ngIf="!editProfileAdditionalInfoToggle">
        <span class="ma-field__label">Time Zone</span>
        <span class="ma-field__value">{{ timezone?.text }}</span>
      </div>
      <div class="form-field" *ngIf="editProfileAdditionalInfoToggle">
        <label class="form-label" for="timezoneSelect">Time Zone</label>
        <select
          id="timezoneSelect"
          class="form-select"
          [(ngModel)]="timezone"
          data-testid="profile-additional-info-timezone-select"
        >
          <option *ngFor="let timeZone of timeZones" [ngValue]="timeZone">
            {{ timeZone.text }}
          </option>
        </select>
      </div>
    </div>
  </section>

  <!-- Additional Recipients -->
  <section class="card ma-card" data-testid="profile-cc-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Additional Recipients (Optional)</h2>
      <ng-container *ngIf="!editCcInfoToggle">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          data-testid="profile-cc-edit"
          (click)="editCCInfo()"
        >
          <span class="material-icons">edit</span> Edit
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn--primary ma-edit-btn"
        *ngIf="editCcInfoToggle"
        data-testid="profile-cc-save"
        (click)="saveCCInfo()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>
    <div class="ma-grid">
      <div class="ma-field" *ngIf="!editCcInfoToggle">
        <span class="ma-field__label">Name 1</span>
        <span class="ma-field__value">{{ user.ccName1 }}</span>
      </div>
      <div class="form-field" *ngIf="editCcInfoToggle">
        <label class="form-label" for="ccName1">Name 1</label>
        <input
          id="ccName1"
          type="text"
          [(ngModel)]="ccName1"
          class="input"
          data-testid="profile-cc-name1-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editCcInfoToggle">
        <span class="ma-field__label">Name 2</span>
        <span class="ma-field__value">{{ user.ccName2 }}</span>
      </div>
      <div class="form-field" *ngIf="editCcInfoToggle">
        <label class="form-label" for="ccName2">Name 2</label>
        <input
          id="ccName2"
          type="text"
          [(ngModel)]="ccName2"
          class="input"
          data-testid="profile-cc-name2-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editCcInfoToggle">
        <span class="ma-field__label">Email 1</span>
        <span class="ma-field__value">{{ user.ccEmail1 }}</span>
      </div>
      <div class="form-field" *ngIf="editCcInfoToggle">
        <label class="form-label" for="ccEmail1">Email 1</label>
        <input
          id="ccEmail1"
          type="text"
          [(ngModel)]="ccEmail1"
          class="input"
          data-testid="profile-cc-email1-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editCcInfoToggle">
        <span class="ma-field__label">Email 2</span>
        <span class="ma-field__value">{{ user.ccEmail2 }}</span>
      </div>
      <div class="form-field" *ngIf="editCcInfoToggle">
        <label class="form-label" for="ccEmail2">Email 2</label>
        <input
          id="ccEmail2"
          type="text"
          [(ngModel)]="ccEmail2"
          class="input"
          data-testid="profile-cc-email2-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editCcInfoToggle">
        <span class="ma-field__label">Phone Number 1</span>
        <span class="ma-field__value">{{ user.ccPhone1 }}</span>
      </div>
      <div class="form-field" *ngIf="editCcInfoToggle">
        <label class="form-label" for="ccPhone1">Phone Number 1</label>
        <input
          id="ccPhone1"
          type="text"
          [(ngModel)]="ccPhone1"
          class="input"
          data-testid="profile-cc-phone1-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editCcInfoToggle">
        <span class="ma-field__label">Phone Number 2</span>
        <span class="ma-field__value">{{ user.ccPhone2 }}</span>
      </div>
      <div class="form-field" *ngIf="editCcInfoToggle">
        <label class="form-label" for="ccPhone2">Phone Number 2</label>
        <input
          id="ccPhone2"
          type="text"
          [(ngModel)]="ccPhone2"
          class="input"
          data-testid="profile-cc-phone2-input"
        />
      </div>
    </div>
  </section>

  <!-- Company -->
  <section class="card ma-card" data-testid="company-info-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Company</h2>
      <ng-container *ngIf="!editOrgInfoToggle">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          data-testid="company-info-edit"
          (click)="editOrgInfo()"
        >
          <span class="material-icons">edit</span> Edit
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn--primary ma-edit-btn"
        *ngIf="editOrgInfoToggle"
        data-testid="company-info-save"
        (click)="saveOrgInfo()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>
    <div class="ma-grid">
      <div class="ma-field" *ngIf="!editOrgInfoToggle">
        <span class="ma-field__label">Company Name</span>
        <span class="ma-field__value">{{ user.organization?.name }}</span>
      </div>
      <div class="form-field" *ngIf="editOrgInfoToggle">
        <label class="form-label" for="orgName">Company Name</label>
        <input
          id="orgName"
          type="text"
          [(ngModel)]="orgName"
          class="input"
          data-testid="company-info-name-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editOrgInfoToggle">
        <span class="ma-field__label">Phone</span>
        <span class="ma-field__value">{{ user.organization?.phone }}</span>
      </div>
      <div class="form-field" *ngIf="editOrgInfoToggle">
        <label class="form-label" for="orgPhone">Phone</label>
        <input
          id="orgPhone"
          type="text"
          [(ngModel)]="orgPhone"
          class="input"
          data-testid="company-info-phone-input"
        />
      </div>
    </div>
  </section>

  <!-- Company Address (physical + mailing) -->
  <section class="card ma-card" data-testid="company-address-card">
    <div class="ma-card__header">
      <h2 class="ma-card__title">Company Address</h2>
      <ng-container *ngIf="!editOrgAddressToggle">
        <button
          type="button"
          class="btn btn--secondary ma-edit-btn"
          data-testid="company-address-edit"
          (click)="editOrgAddress()"
        >
          <span class="material-icons">edit</span> Edit
        </button>
      </ng-container>
      <button
        type="button"
        class="btn btn--primary ma-edit-btn"
        *ngIf="editOrgAddressToggle"
        data-testid="company-address-save"
        (click)="saveCompanyAddress()"
      >
        <span class="material-icons">save</span> Save
      </button>
    </div>

    <h3 class="ma-subheading">Physical Address</h3>
    <div class="ma-grid">
      <div class="ma-field" *ngIf="!editOrgAddressToggle">
        <span class="ma-field__label">Street Address</span>
        <span class="ma-field__value">{{
          user.organization?.location?.street
        }}</span>
      </div>
      <div class="form-field" *ngIf="editOrgAddressToggle">
        <label class="form-label" for="orgStreet">Street Address</label>
        <input
          id="orgStreet"
          type="text"
          [(ngModel)]="orgStreetAddress"
          class="input"
          data-testid="company-address-street-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editOrgAddressToggle">
        <span class="ma-field__label">City</span>
        <span class="ma-field__value">{{
          user.organization?.location?.city
        }}</span>
      </div>
      <div class="form-field" *ngIf="editOrgAddressToggle">
        <label class="form-label" for="orgCity">City</label>
        <input
          id="orgCity"
          type="text"
          [(ngModel)]="orgCity"
          class="input"
          data-testid="company-address-city-input"
        />
      </div>
      <div class="ma-field" *ngIf="!editOrgAddressToggle">
        <span class="ma-field__label">State</span>
        <span class="ma-field__value">{{
          decodeState(user.organization?.location?.state)
        }}</span>
      </div>
      <div class="form-field" *ngIf="editOrgAddressToggle">
        <label class="form-label" for="orgStateSelect">State</label>
        <select
          id="orgStateSelect"
          class="form-select"
          [(ngModel)]="orgState"
          data-testid="company-address-state-select"
        >
          <option
            *ngFor="let stateCountyDetail of stateCountyDetails"
            [value]="stateCountyDetail.state"
          >
            {{ stateCountyDetail.name }}
          </option>
        </select>
      </div>
      <div class="ma-field" *ngIf="!editOrgAddressToggle">
        <span class="ma-field__label">Zip Code</span>
        <span class="ma-field__value">{{
          user.organization?.location?.zipcode
        }}</span>
      </div>
      <div class="form-field" *ngIf="editOrgAddressToggle">
        <label class="form-label" for="orgZipcode">Zip Code</label>
        <input
          id="orgZipcode"
          type="text"
          [(ngModel)]="orgZipcode"
          class="input"
          data-testid="company-address-zipcode-input"
        />
      </div>
    </div>

    <div class="ma-checkbox-field ma-mailing-toggle" *ngIf="editOrgAddressToggle">
      <input
        id="orgMailingSameAsPhysical"
        type="checkbox"
        [(ngModel)]="orgMailingSameAsPhysical"
        (ngModelChange)="onMailingSameAsPhysicalChange()"
        data-testid="company-address-mailing-same-checkbox"
      />
      <label for="orgMailingSameAsPhysical"
        >Mailing address same as physical</label
      >
    </div>

    <h3 class="ma-subheading">Mailing Address</h3>
    <div class="ma-grid" *ngIf="orgMailingSameAsPhysical; else mailingFields">
      <div class="ma-field">
        <span class="ma-field__label">Street Address</span>
        <span class="ma-field__value">{{
          user.organization?.location?.street
        }}</span>
      </div>
      <div class="ma-field">
        <span class="ma-field__label">City</span>
        <span class="ma-field__value">{{
          user.organization?.location?.city
        }}</span>
      </div>
      <div class="ma-field">
        <span class="ma-field__label">State</span>
        <span class="ma-field__value">{{
          decodeState(user.organization?.location?.state)
        }}</span>
      </div>
      <div class="ma-field">
        <span class="ma-field__label">Zip Code</span>
        <span class="ma-field__value">{{
          user.organization?.location?.zipcode
        }}</span>
      </div>
    </div>
    <ng-template #mailingFields>
      <div class="ma-grid">
        <div class="ma-field" *ngIf="!editOrgAddressToggle">
          <span class="ma-field__label">Street Address</span>
          <span class="ma-field__value">{{ orgMailingStreetAddress }}</span>
        </div>
        <div class="form-field" *ngIf="editOrgAddressToggle">
          <label class="form-label" for="orgMailingStreet"
            >Street Address</label
          >
          <input
            id="orgMailingStreet"
            type="text"
            [(ngModel)]="orgMailingStreetAddress"
            class="input"
            data-testid="company-address-mailing-street-input"
          />
        </div>
        <div class="ma-field" *ngIf="!editOrgAddressToggle">
          <span class="ma-field__label">City</span>
          <span class="ma-field__value">{{ orgMailingCity }}</span>
        </div>
        <div class="form-field" *ngIf="editOrgAddressToggle">
          <label class="form-label" for="orgMailingCity">City</label>
          <input
            id="orgMailingCity"
            type="text"
            [(ngModel)]="orgMailingCity"
            class="input"
            data-testid="company-address-mailing-city-input"
          />
        </div>
        <div class="ma-field" *ngIf="!editOrgAddressToggle">
          <span class="ma-field__label">State</span>
          <span class="ma-field__value">{{
            decodeState(orgMailingState)
          }}</span>
        </div>
        <div class="form-field" *ngIf="editOrgAddressToggle">
          <label class="form-label" for="orgMailingStateSelect">State</label>
          <select
            id="orgMailingStateSelect"
            class="form-select"
            [(ngModel)]="orgMailingState"
            data-testid="company-address-mailing-state-select"
          >
            <option
              *ngFor="let stateCountyDetail of stateCountyDetails"
              [value]="stateCountyDetail.state"
            >
              {{ stateCountyDetail.name }}
            </option>
          </select>
        </div>
        <div class="ma-field" *ngIf="!editOrgAddressToggle">
          <span class="ma-field__label">Zip Code</span>
          <span class="ma-field__value">{{ orgMailingZipcode }}</span>
        </div>
        <div class="form-field" *ngIf="editOrgAddressToggle">
          <label class="form-label" for="orgMailingZipcode">Zip Code</label>
          <input
            id="orgMailingZipcode"
            type="text"
            [(ngModel)]="orgMailingZipcode"
            class="input"
            data-testid="company-address-mailing-zipcode-input"
          />
        </div>
      </div>
    </ng-template>
  </section>
  </div>

  <!-- Documents — the vendor's profile documents (Resume / Certifications /
       Licenses), rendered full-width below the profile cards. Moved here from
       the standalone Documents page, which now hosts Zone Documents only.
       Styled as a profile section-card to match the cards above. -->
  <section
    class="card ma-card ma-documents-card"
    data-testid="documents-profile"
  >
    <div class="ma-card__header">
      <h2 class="ma-card__title">Documents</h2>
      <div class="ma-doc-upload">
        <label
          for="profile-doc-upload"
          class="btn btn--primary ma-edit-btn"
          data-testid="documents-profile-upload"
        >
          <span class="material-icons">upload_file</span> Upload
        </label>
        <input
          id="profile-doc-upload"
          type="file"
          multiple
          required
          data-testid="documents-profile-upload-input"
          (change)="uploadProfileDocument($event)"
          accept=".pdf, .txt, .csv, .gif, .png, .tiff, .jpg, .doc, .docx, .xls, .xlsx, .html, .zip"
        />
      </div>
    </div>
    <p class="ma-doc-subtitle">
      Upload profile documents like your Resume, Certifications and Insurance
      here.
    </p>
    <div
      class="ma-doc-cards"
      *ngIf="user.documents && user.documents.length > 0; else noProfileDocs"
    >
      <div class="ma-doc-card" *ngFor="let profileDocument of user.documents">
        <span class="material-icons ma-doc-card__file-icon">description</span>
        <div class="ma-doc-card__body">
          <div class="ma-doc-card__name" [title]="profileDocument.fileName">
            {{ profileDocument.fileName }}
          </div>
        </div>
        <div class="ma-doc-card__actions">
          <button
            *ngIf="isPdf(profileDocument)"
            type="button"
            class="ma-doc-icon-btn"
            title="Preview"
            [attr.data-testid]="'documents-profile-' + profileDocTestKey(profileDocument) + '-preview'"
            (click)="openPdfViewer(profileDocument)"
          >
            <span class="material-icons">visibility</span>
          </button>
          <button
            type="button"
            class="ma-doc-icon-btn"
            title="Download"
            [attr.data-testid]="'documents-profile-' + profileDocTestKey(profileDocument) + '-download'"
            (click)="downloadDocument(profileDocument)"
          >
            <span class="material-icons">file_download</span>
          </button>
          <button
            type="button"
            class="ma-doc-icon-btn ma-doc-icon-btn--danger"
            title="Delete"
            [attr.data-testid]="'documents-profile-' + profileDocTestKey(profileDocument) + '-delete'"
            (click)="deleteProfileDocument(profileDocument.id)"
          >
            <span class="material-icons">delete</span>
          </button>
        </div>
      </div>
    </div>
    <ng-template #noProfileDocs>
      <p class="ma-doc-empty">No profile documents</p>
    </ng-template>
  </section>
</div>

<welcome-dialog
  [active]="openWelcomeDialog"
  [user]="user"
  (modalClosed)="toggleWelcomeDialog()"
/>
